import type { FC } from "react";
import { defaultColor } from "../constants";
import type { IconProps } from "./types";
export const Messages: FC<IconProps> = ({
  color = defaultColor,
  height = 24,
}) => (
  <svg
    width="25"
    height={height}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.5 15.306L9.56627 15.2545H13.6217C15.4885 15.2545 17 13.7411 17 11.8756V8.11172C17.8779 8.11082 18.7531 8.10996 19.6211 8.10939C20.6588 8.10871 21.5 8.94991 21.5 9.98759V15.8756C21.5 16.9133 20.6586 17.7545 19.6209 17.7545H19.4373V19.327C19.4373 19.7938 18.9022 20.0583 18.5313 19.7748L15.8884 17.7545H11.378C10.3404 17.7545 9.5 16.9133 9.5 15.8756V15.306Z"
      fill={color}
    />
    <path
      d="M13.6193 4.11568C14.6577 4.11563 15.5 4.95709 15.5 5.9955V11.8756C15.5 12.9132 14.6594 13.7544 13.6217 13.7544C11.8924 13.7544 9.52538 13.7544 9.05173 13.7544L6.47234 15.76C6.10208 16.0479 5.5627 15.784 5.5627 15.315V13.7544C5.50997 13.7544 5.44799 13.7544 5.37905 13.7544C4.34139 13.7544 3.5 12.9132 3.5 11.8756V5.98757C3.5 4.9499 4.34118 4.10869 5.37885 4.10938C8.10193 4.11116 10.8961 4.11581 13.6193 4.11568Z"
      fill={color}
    />
  </svg>
);
